export default __webpack_public_path__ + "static/media/Business_insider_logo.41939a41.png";